var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullPage',{attrs:{"title":"Cashup"}},[(_vm.showForm)?_c('BasicCashupForm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }